export default __webpack_public_path__ + "assets/95cae41a76ab8b0479f6fab24a97a4c2.jpg";